<template>
  <div>
    <!-- 面包屑 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item> 结题验收 </el-breadcrumb-item>
      <el-breadcrumb-item>课题评审</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card>
      <el-select v-model="projectCategory" placeholder="请选择课题类别" @change="getProjectInfoList">
        <el-option v-for="item in projectCategorys" :key="item.id" :label="item.name" :value="item.name">
        </el-option>
      </el-select>

      <div v-for="item in projcetDistribute" :key="item.direction">
        <h3>课题方向： {{ item.direction }}</h3>
        <!-- 申报书列表 -->
        <el-table :data="item.data" style="width: 100%">
          <el-table-column type="index" label="序号" width="60"></el-table-column>
          <el-table-column prop="pname" label="名称" width="380"></el-table-column>
          <el-table-column prop="leader_name" label="申报人" width="180"></el-table-column>
          <el-table-column prop="new_pid" label="课题新编号" width="180"></el-table-column>
          <el-table-column label="查看" width="80">
            <template slot-scope="scope">
              <el-button size="mini" :plain="true" type="primary" icon="el-icon-search" circle
                @click="showInfoForm(scope.row)">
              </el-button>
            </template>
          </el-table-column>
          <el-table-column label="评审" width="150">
            <template slot-scope="scope">
              <el-button size="mini" :plain="true" type="primary" @click="assessButton(scope.row)">评审
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-card>


    <!-- 申报书查看 -->
    <el-card v-show="infoFormVisible" id="id-el-card-info">
      <!-- 文件列表 -->
      <el-card>
        <h2>点击查看按钮，可以直接预览</h2>
        <h3>课题相关文件</h3>
        <div class="div-file">
          <el-table :data="fileList" style="width: 551px" :header-cell-style="{ background: '#fafafa' }">
            <el-table-column prop="name" label="文件名" width="300"></el-table-column>
            <el-table-column prop="create_time" label="创建时间" width="150">
              <template slot-scope="scope">
                {{ scope.row.create_time | fmtdate }}
              </template>
            </el-table-column>
            <el-table-column label="操作" width="100">
              <template slot-scope="scope">
                <el-button size="mini" :plain="true" type="primary" icon="el-icon-search" circle
                  @click="getFileCode(scope.row)"></el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <h3>计划任务书</h3>
        <div class="div-file">
          <el-table :data="fileListSignAgreement" style="width:551px;" :header-cell-style="{ background: '#fafafa' }">
            <el-table-column prop="name" label="文件名" width="300"></el-table-column>
            <el-table-column prop="create_time" label="创建时间" width="150">
              <template slot-scope="scope">
                {{ scope.row.create_time | fmtdate }}
              </template>
            </el-table-column>
            <el-table-column label="操作" width="100">
              <template slot-scope="scope">
                <el-button size="mini" :plain="true" type="primary" icon="el-icon-search" circle
                  @click="getFileCode(scope.row)"></el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <h3>测试数据与分析报告</h3>
        <div class="div-file">
          <el-table :data="fileListTestData" style="width:551px;" :header-cell-style="{ background: '#fafafa' }">
            <el-table-column prop="name" label="文件名" width="300"></el-table-column>
            <el-table-column prop="create_time" label="创建时间" width="150">
              <template slot-scope="scope">
                {{ scope.row.create_time | fmtdate }}
              </template>
            </el-table-column>
            <el-table-column label="操作" width="100">
              <template slot-scope="scope">
                <el-button size="mini" :plain="true" type="primary" icon="el-icon-search" circle
                  @click="getFileCode(scope.row)"></el-button>
                <!-- <el-button size="mini" :plain="true" type="primary" icon="el-icon-download" circle
                  @click="downloadFile(scope.row)"></el-button> -->
              </template>
            </el-table-column>
          </el-table>
        </div>
        <h3>中期成果报告</h3>
        <div class="div-file">
          <el-table :data="fileListMiddleCheck" style="width:551px;" :header-cell-style="{ background: '#fafafa' }">
            <el-table-column prop="name" label="文件名" width="300"></el-table-column>
            <el-table-column prop="create_time" label="创建时间" width="150">
              <template slot-scope="scope">
                {{ scope.row.create_time | fmtdate }}
              </template>
            </el-table-column>
            <el-table-column label="操作" width="100">
              <template slot-scope="scope">
                <el-button size="mini" :plain="true" type="primary" icon="el-icon-search" circle
                  @click="getFileCode(scope.row)">
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <h3>结题验收材料</h3>
        <div class="div-file">
          <el-table :data="fileListFinalCheck" style="width:551px;" :header-cell-style="{ background: '#fafafa' }">
            <el-table-column prop="name" label="文件名" width="300"></el-table-column>
            <el-table-column prop="create_time" label="创建时间" width="150">
              <template slot-scope="scope">
                {{ scope.row.create_time | fmtdate }}
              </template>
            </el-table-column>
            <el-table-column label="操作" width="100">
              <template slot-scope="scope">
                <el-button size="mini" :plain="true" type="primary" icon="el-icon-search" circle
                  @click="getFileCode(scope.row)">
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>

      </el-card>
      <!-- 申报书详情 -->
      <el-card>
        <el-row>
          <el-col :span="24">
            <div class="header-edit">申报书详情</div>
          </el-col>
        </el-row>
        <el-card>
          <el-col class="el-col-addForm">
            <span> 课题方向：</span>
            <span>{{ editForm.category_direction }}</span>
            <span> 课题名称：</span>
            <el-input :disabled="true" v-model="editForm.name"></el-input>
          </el-col>
        </el-card>
        <!-- 项目主持人情况 -->
        <el-card class="el-card-leader">
          <div class="div-leader">
            <span>项目主持人情况</span>
          </div>
          <el-table :data="projectLeader" border style="width: 1021px" :header-cell-style="{ background: '#fafafa' }">
            <el-table-column prop="username" label="姓名" width="80"></el-table-column>
            <el-table-column prop="gender" label="性别" width="60"></el-table-column>
            <el-table-column prop="national" label="民族" width="80"></el-table-column>
            <el-table-column prop="birth" label="出生年月" width="80"></el-table-column>
            <el-table-column prop="duty" label="行政职务" width="120"></el-table-column>
            <el-table-column prop="title" label="专业职称" width="120"></el-table-column>
            <el-table-column prop="major" label="研究专长" width="140"></el-table-column>
            <el-table-column prop="education" label="最后学历" width="80"></el-table-column>
            <el-table-column prop="degree" label="最后学位" width="80"></el-table-column>
            <el-table-column prop="province" label="所在省(自治区、直辖市)" width="180"></el-table-column>
          </el-table>
          <el-table :data="projectLeader" border style="width: 1021px; margin-top: -1px"
            :header-cell-style="{ background: '#fafafa' }">
            <el-table-column prop="organization" label="工作单位" width="280"></el-table-column>
            <el-table-column prop="tel" label="联系电话" width="160"></el-table-column>
            <el-table-column prop="email" label="E-mail" width="200"></el-table-column>
            <el-table-column prop="addr" label="通讯地址" width="280"></el-table-column>
            <el-table-column prop="zipcode" label="邮政编码" width="100"></el-table-column>
          </el-table>
        </el-card>
        <!-- 主要参加者情况 -->
        <el-card>
          <div class="member">
            <span> 主要参加者情况</span>
          </div>
          <el-table :data="projectMember" style="width: 1021px" :header-cell-style="{ background: '#fafafa' }">
            <el-table-column prop="name" label="姓名" width="80"></el-table-column>
            <el-table-column prop="organization" label="单位" width="280"></el-table-column>
            <el-table-column prop="education" label="最后学历" width="80"></el-table-column>
            <el-table-column prop="major" label="所学专业" width="160"></el-table-column>
            <el-table-column prop="duty" label="技术职务" width="120"></el-table-column>
            <el-table-column prop="division" label="研究分工" width="200"></el-table-column>
          </el-table>
        </el-card>
        <!-- 预期成果形式 -->
        <el-card>
          <el-row class="el-row-detail">
            <el-col :span="8"><span> 预期成果形式：</span>
              <el-input :disabled="true" v-model="editForm.result_type"></el-input>
            </el-col>
            <el-col :span="8"><span> 字数：</span>
              <el-input :disabled="true" v-model="editForm.total_words"></el-input>
            </el-col>
            <el-col :span="8"><span> 预计完成时间：</span>
              <el-input :disabled="true" v-model="editForm.complete_time"></el-input>
            </el-col>
          </el-row>
        </el-card>
        <!-- 课题研究计划 -->
        <el-card>
          <div>课题研究计划</div>
          <quill-editor :disabled="true" v-model="editForm.content" :options="editorOption" class="editor">
          </quill-editor>
        </el-card>
        <!-- 预算 -->
        <el-card>
          <h3>课题预算</h3>
          <div class="div-budget">
            <div>
              <table>
                <tr>
                  <td>序号</td>
                  <td>预算科目名称</td>
                  <td>预算金额（万元）</td>
                  <td>测算依据（另附页说明）</td>
                </tr>
                <tr>
                  <td>1</td>
                  <td>经费总额</td>
                  <td>
                    <el-input v-model="budget.f1"></el-input>
                  </td>
                  <td>
                    <el-input maxlength="12" v-model="budget.s1"></el-input>
                  </td>
                </tr>
                <tr>
                  <td>2</td>
                  <td>一、直接费用</td>
                  <td>
                    <el-input v-model="budget.f2"></el-input>
                  </td>
                  <td>
                    <el-input maxlength="12" v-model="budget.s2"></el-input>
                  </td>
                </tr>
                <tr>
                  <td>3</td>
                  <td>1.设备费</td>
                  <td>
                    <el-input v-model="budget.f3"></el-input>
                  </td>
                  <td>
                    <el-input maxlength="12" v-model="budget.s3"></el-input>
                  </td>
                </tr>
                <tr>
                  <td>4</td>
                  <td>（1）购置设备费</td>
                  <td>
                    <el-input v-model="budget.f4"></el-input>
                  </td>
                  <td>
                    <el-input maxlength="12" v-model="budget.s4"></el-input>
                  </td>
                </tr>
                <tr>
                  <td>5</td>
                  <td>（2）试制设备费</td>
                  <td>
                    <el-input v-model="budget.f5"></el-input>
                  </td>
                  <td>
                    <el-input maxlength="12" v-model="budget.s5"></el-input>
                  </td>
                </tr>
                <tr>
                  <td>6</td>
                  <td>（3）设备改造与租赁费</td>
                  <td>
                    <el-input v-model="budget.f6"></el-input>
                  </td>
                  <td>
                    <el-input maxlength="12" v-model="budget.s6"></el-input>
                  </td>
                </tr>
                <tr>
                  <td>7</td>
                  <td>2.材料费</td>
                  <td>
                    <el-input v-model="budget.f7"></el-input>
                  </td>
                  <td>
                    <el-input maxlength="12" v-model="budget.s7"></el-input>
                  </td>
                </tr>
                <tr>
                  <td>8</td>
                  <td>3.测试化验加工费</td>
                  <td>
                    <el-input v-model="budget.f8"></el-input>
                  </td>
                  <td>
                    <el-input maxlength="12" v-model="budget.s8"></el-input>
                  </td>
                </tr>
                <tr>
                  <td>9</td>
                  <td>4.差旅费</td>
                  <td>
                    <el-input v-model="budget.f9"></el-input>
                  </td>
                  <td>
                    <el-input maxlength="12" v-model="budget.s9"></el-input>
                  </td>
                </tr>
                <tr>
                  <td>10</td>
                  <td>其中：市内交通费</td>
                  <td>
                    <el-input v-model="budget.f10"></el-input>
                  </td>
                  <td>
                    <el-input maxlength="12" v-model="budget.s10"></el-input>
                  </td>
                </tr>
                <tr>
                  <td>11</td>
                  <td>5.会议费</td>
                  <td>
                    <el-input v-model="budget.f11"></el-input>
                  </td>
                  <td>
                    <el-input maxlength="12" v-model="budget.s11"></el-input>
                  </td>
                </tr>
                <tr>
                  <td>12</td>
                  <td>6.出版/印刷/文献/信息传播/知识产权事务费</td>
                  <td>
                    <el-input v-model="budget.f12"></el-input>
                  </td>
                  <td>
                    <el-input maxlength="12" v-model="budget.s12"></el-input>
                  </td>
                </tr>
                <tr>
                  <td>13</td>
                  <td>7.劳务费</td>
                  <td>
                    <el-input v-model="budget.f13"></el-input>
                  </td>
                  <td>
                    <el-input maxlength="12" v-model="budget.s13"></el-input>
                  </td>
                </tr>
                <tr>
                  <td>14</td>
                  <td>8.专家咨询费</td>
                  <td>
                    <el-input v-model="budget.f14"></el-input>
                  </td>
                  <td>
                    <el-input maxlength="12" v-model="budget.s14"></el-input>
                  </td>
                </tr>
                <tr>
                  <td>15</td>
                  <td>二、间接经费（不得超过课题经费总额的10%）</td>
                  <td>
                    <el-input v-model="budget.f15"></el-input>
                  </td>
                  <td>
                    <el-input maxlength="12" v-model="budget.s15"></el-input>
                  </td>
                </tr>
                <tr>
                  <td>16</td>
                  <td>1.管理费用</td>
                  <td>
                    <el-input v-model="budget.f16"></el-input>
                  </td>
                  <td>
                    <el-input maxlength="12" v-model="budget.s16"></el-input>
                  </td>
                </tr>
                <tr>
                  <td>17</td>
                  <td>2.其他具体说明</td>
                  <td>
                    <el-input v-model="budget.f17"></el-input>
                  </td>
                  <td>
                    <el-input maxlength="12" v-model="budget.s17"></el-input>
                  </td>
                </tr>
              </table>
              <div style="margin-top: 20px;">
                <span style="font-size: 20px;">测算依据说明:</span>
              </div>
              <quill-editor v-model="budget.reason" :options="editorOption" class="editor"></quill-editor>
            </div>
          </div>
        </el-card>
      </el-card>
    </el-card>


    <!-- 评审对话框 -->
    <el-dialog title="课题评审" :visible.sync="assessDialogVisible">
      <h3>课题方向：{{ projectAssess.category_direction }}</h3>
      <h3>课题名称：{{ projectAssess.pname }}</h3>
      <h3>作者：{{ projectAssess.leader_name }}</h3>
      <!-- <el-card>
        <div class="divScore">一、专家对科研项目的基本评定（请点击相应的评分）：</div>
        <el-table :data="assessScore">
          <el-table-column prop="name" label="评分项"></el-table-column>
          <el-table-column prop="score" label="评分" width="500">
            <template slot-scope="scope">
              <el-radio-group v-model="scope.row.score" v-for="item in scope.row.scores" :key="item.score">
                <el-radio :label="item.score">
                  {{item.name}}
                </el-radio>
              </el-radio-group>
            </template>
          </el-table-column>
        </el-table>
      </el-card> -->
      <el-card>
        <div class="divSuggestion">课题验收评价意见</div>
        <quill-editor v-model="assessSuggestion" :options="editorOption" class="assess-uggestion">
        </quill-editor>
        <!-- <el-input type="textarea" :rows="10" v-model="assessSuggestion"
          placeholder="（评审意见要点：研究路径、方法的科学性、完成情况及产生的效果及效益等）">
        </el-input> -->
      </el-card>
      <div style="margin-top: 20px;">
        <span>请输入签名密码 </span>
        <el-input style="width: 200px;" v-model="password" show-password></el-input>
      </div>
      <!-- <el-button type="primary" @click="save()">保存</el-button> -->
      <el-button type="primary" @click="assess()">提交</el-button>
    </el-dialog>

    <!-- pdf查看 -->
    <el-dialog :visible.sync="pdfVisible" width="80%" :style="{ top: '-150px' }">
      <div class="onlineHelp cg-box">
        <div class="tools">
          <el-button type="mini" @click="zoomIn">放大</el-button>
          <el-button type="mini" @click="zoomOut">缩小</el-button>
        </div>
        <iframe :src="pdfSrc" width="100%" :height="iframeHeight" style="border:none;"></iframe>
      </div>
    </el-dialog>
    <!-- 图片查看 -->
    <el-dialog title="文件查看" :visible.sync="picVisible" width="50%">
      <el-image :src="picSrc"></el-image>
    </el-dialog>

    <!-- 视频查看 -->
    <el-dialog title="文件查看" :visible.sync="videoVisible" width="50%" @close='videoClose' fullscreen>
      <video-player class="video-player vjs-custom-skin" ref="videoPlayer" :playsinline="true" :options="playerOptions">
      </video-player>
    </el-dialog>
  </div>
</template>

<script>
//富文本
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import * as Quill from 'quill'
import {
  quillEditor
} from 'vue-quill-editor'
import {
  ImageDrop
} from 'quill-image-drop-module'
import ImageResize from 'quill-image-resize-module'
Quill.register('modules/imageDrop', ImageDrop);
Quill.register('modules/imageResize', ImageResize);

//下载
import fileDownload from 'js-file-download'

// pdf预览
import pdf from 'vue-pdf'
import {
  videoPlayer
} from 'vue-video-player'
import 'video.js/dist/video-js.css'

export default {
  components: {
    quillEditor,
    pdf,
    videoPlayer
  },
  data() {
    return {
      // 查看图片
      picSrc: '',
      picVisible: false,

      //pdf查看
      pdfSrc: '', // PDF 文件的 URL
      pdfVisible: false, // 控制 PDF 弹窗显示
      iframeHeight: '800px', // iframe 的高度，可以通过 zoomIn 和 zoomOut 来调整

      // 视频查看
      videoVisible: false,
      playerOptions: {
        playbackRates: [0.5, 1.0, 1.5, 2.0], // 可选的播放速度
        autoplay: false, // 如果为true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 是否视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [{
          type: "video/mp4", // 类型
          src: '' // url地址
        }],
        poster: '', // 封面地址
        notSupportedMessage: '视频正在缓存，请稍候……', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true, // 当前时间和持续时间的分隔符
          durationDisplay: true, // 显示持续时间
          remainingTimeDisplay: false, // 是否显示剩余时间功能
          currentTimeDisplay: true, // 当前时间
          volumeControl: true, // 声音控制键
          progressControl: false, // 进度条
          playToggle: false, // 暂停-播放 按钮
          fullscreenToggle: true // 是否显示全屏按钮
        }
      },

      // editContent: '',
      // pid: '',
      userid: '',
      projectCategory: '',
      projectCategorys: [],
      projcetDistribute: [],
      projectAssess: {}, //评审按钮传入的待评审课题
      //评审对话框
      assessDialogVisible: false,
      //评审评分信息
      assessScore: [{
        name: '1、课题按计划进展情况',
        scores: [{
          name: '很好',
          score: 5
        },
        {
          name: '较好',
          score: 3
        },
        {
          name: '一般',
          score: 2
        },
        {
          name: '较差',
          score: 1
        }
        ],
        score: 0
      },
      {
        name: '2、研究路径、方法的科学性',
        scores: [{
          name: '很好',
          score: 5
        },
        {
          name: '较好',
          score: 3
        },
        {
          name: '一般',
          score: 2
        },
        {
          name: '较差',
          score: 1
        }
        ],
        score: 0
      },
      {
        name: '3、取得的主要阶段性成果',
        scores: [{
          name: '强',
          score: 5
        },
        {
          name: '较强',
          score: 3
        },
        {
          name: '一般',
          score: 2
        },
        {
          name: '较差',
          score: 1
        }
        ],
        score: 0
      },
      {
        name: '4、课题负责人和成员参加研究情况',
        scores: [{
          name: '高',
          score: 5
        },
        {
          name: '较高',
          score: 3
        },
        {
          name: '一般',
          score: 2
        },
        {
          name: '较低',
          score: 1
        }
        ],
        score: 0
      },
      {
        name: '5、下一阶段研究计划安排',
        scores: [{
          name: '强',
          score: 5
        },
        {
          name: '较强',
          score: 3
        },
        {
          name: '一般',
          score: 2
        },
        {
          name: '较差',
          score: 1
        }
        ],
        score: 0
      },
      {
        name: '6、课题时间安排的合理性',
        scores: [{
          name: '很好',
          score: 5
        },
        {
          name: '较好',
          score: 3
        },
        {
          name: '一般',
          score: 2
        },
        {
          name: '较差',
          score: 1
        }
        ],
        score: 0
      },
      {
        name: '7、经费安排的合理性',
        scores: [{
          name: '很好',
          score: 5
        },
        {
          name: '较好',
          score: 3
        },
        {
          name: '一般',
          score: 2
        },
        {
          name: '较差',
          score: 1
        }
        ],
        score: 0
      },
      ],
      // 评审建议
      assessSuggestion: '',
      password: '',
      assessDate: '',

      //以下为查看申报书相关
      pid: "",
      projectInfo: [], //课题列表
      projectInfoShow: {}, //选中查看的
      projectStatus: [],
      status: "",
      projectLeader: [], //主持人，返回的是列表
      leader: {}, //主持人，取列表第一项
      projectMember: [], //本项目参加人
      infoFormVisible: false,
      editForm: {}, //编辑申报书
      auditInfo: {},
      editLeaderVisible: false, //显示编辑主持人对话框
      fileList: [], //附件列表
      fileListSignAgreement: [], //保密协议及计划任务书
      fileListMiddleCheck: [], //中期检查
      fileListFinalCheck: [], //结题验收
      fileListTestData: [], //测试数据与分析报告

      infoDialogVisible: false, //对话框
      projectInfoPng: [], //课题信息图片
      projectInfoPngIsNull: true, //图片是否为空，显示“请等待详情页面加载……”
      budget: {},
      // qill-editor
      editorOption: {}

    }
  },

  created() {
    this.userid = localStorage.getItem("userid")
    this.username = localStorage.getItem("username")
    this.getProjectCategory()
    let d = new Date()
    this.assessDate = d.getFullYear() + '年' + (d.getMonth() + 1) + '月' + d.getDate() + '日'
  },

  watch: {
    projectInfoShow() {
      this.editForm = this.projectInfoShow;
      this.budget = this.editForm.budget
      this.getProjectLeader(this.editForm.leader);
    }
  },

  methods: {
    //获取课题类别
    async getProjectCategory() {
      const res = await this.axios.get(`/projectCategory/`)
      if (res.status === 200) {
        this.projectCategorys = res.data.results
      }
    },

    // 课题类别下拉框
    async getProjectInfoList() {
      this.projcetDistribute = []
      this.infoFormVisible = false
      this.computeCardVisible = false

      //select的value不能绑定对象，所以循环课题类别，找出projectCategory对应的记录
      let directions = []
      for (let i = 0; i < this.projectCategorys.length; i++) {
        if (this.projectCategorys[i].name == this.projectCategory) {
          directions = this.projectCategorys[i].direction
        }
      }
      // 循环课题方向，取出每个方向的课题加入列表
      for (let i = 0; i < directions.data.length; i++) {
        let url =
          `projectDistribute/?status=结题验收&assessor=${this.userid}&category_direction=${directions.data[i].name}`
        let resInfo = await this.axios.get(url)
        if (resInfo.status == 200) {
          let data = resInfo.data.results
          this.projcetDistribute.push({
            direction: directions.data[i].name,
            data: data
          })
        }
      }
    },


    // 判断文件类型，调用不同的查看方法
    getFileCode(item) {
      let name = item.name.slice(-3)
      if (name == 'jpg' || name == 'png' || name == 'bpm') {
        this.getPicCode(item)
      } else if (name == 'pdf') {
        this.getPdfCode(item)
      } else if (name == 'mp4') {
        this.getVideoCode(item)
      }
    },

    // 将返回的流数据转换为url
    getObjectURL(file) {
      let url = null;
      if (window.createObjectURL != undefined) { // basic
        url = window.createObjectURL(file);
      } else if (window.webkitURL != undefined) { // webkit or chrome
        try {
          url = window.webkitURL.createObjectURL(file);
        } catch (error) {

        }
      } else if (window.URL != undefined) { // mozilla(firefox)
        try {
          url = window.URL.createObjectURL(file);
        } catch (error) { }
      }
      return url;
    },

    // 视频查看
    getVideoCode(item) {
      this.videoVisible = true
      let url = `/downloadFile/?path=${item.path}&name=${item.name}`
      let params = {
        path: item.path,
        name: item.name
      }
      this.axios({
        method: 'post',
        url: url,
        data: params,
        headers: {
          'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        },
        responseType: 'blob' //设置响应的数据类型为一个包含二进制数据的 Blob 对象，必须设置！！！
      }).then(response => {
        this.playerOptions.sources[0].src = this.getObjectURL(response.data);
      }).catch(function (error) {
        console.log(error);
      });
    },
    // 关闭窗口，停止视频
    videoClose() {
      this.playerOptions.sources[0].src = ''
    },

    // 图片查看
    getPicCode(item) {
      this.picVisible = true
      let url = `/downloadFile/?path=${item.path}&name=${item.name}`
      let params = {
        path: item.path,
        name: item.name
      }
      this.axios({
        method: 'post',
        url: url,
        data: params,
        headers: {
          'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        },
        responseType: 'blob' //设置响应的数据类型为一个包含二进制数据的 Blob 对象，必须设置！！！
      }).then(response => {
        this.picSrc = this.getObjectURL(response.data);
      }).catch(function (error) {
        console.log(error);
      });
    },

    // pdf预览
    // 获取 PDF 文件
    getPdfCode(item) {
      this.pdfVisible = true;  // 显示弹窗
      let url = `/downloadFile/?path=${item.path}&name=${item.name}`;
      let params = {
        path: item.path,
        name: item.name
      };

      this.axios({
        method: 'post',
        url: url,
        data: params,
        responseType: 'blob' // 设置响应的数据类型为 Blob
      }).then(response => {
        // 检查是否为 PDF 文件
        const file = response.data;
        const blob = new Blob([file], { type: 'application/pdf' }); // 确保 MIME 类型是 PDF
        this.pdfSrc = URL.createObjectURL(blob); // 创建可供 iframe 使用的 URL
      }).catch(error => {
        console.error("加载 PDF 文件失败:", error);
      });
    },

    // 将 Blob 转换为 URL
    createPdfObjectURL(file) {
      return URL.createObjectURL(file); // 使用 URL.createObjectURL 创建可访问的文件 URL
    },
    // 放大 PDF
    zoomIn() {
      let currentHeight = parseInt(this.iframeHeight);
      this.iframeHeight = `${currentHeight + 100}px`; // 每次放大100px
    },
    // 缩小 PDF
    zoomOut() {
      let currentHeight = parseInt(this.iframeHeight);
      this.iframeHeight = `${Math.max(currentHeight - 100, 300)}px`; // 最小缩小到300px
    },


    //评审按钮
    async assessButton(item) {
      this.assessDialogVisible = !this.assessDialogVisible
      this.projectAssess = item
      // 如果有记录，读取原评审意见
      let res = await this.axios.get('/projectFinalCheck/?pid=' + this.projectAssess.pid)
      this.assessSuggestion = ""
      if (res.data.results.length > 0) {
        // 循环查询结果，找出assessor不为空的记录
        for (let i = 0; i < res.data.results.length; i++) {
          if (res.data.results[i].assessor) {
            this.assessSuggestion = res.data.results[i].assessor_result.assessSuggestion
            break
          }
        }
      }
    },

    // 计算评审结果
    async assess() {
      // 先查询是否有保存记录
      let assessor_list = ""
      let assessor_name_list = ""
      let res = await this.axios.get('/projectFinalCheck/?pid=' + this.projectAssess.pid)
      let id = "" //记录有assessor的记录的id，有则更新，没有则新增

      if (res.data.results.length > 0) {
        // 循环查询结果，找出assessor不为空的记录
        for (let i = 0; i < res.data.results.length; i++) {
          if (res.data.results[i].assessor) {
            assessor_list = res.data.results[i].assessor + this.userid + ','
            assessor_name_list = res.data.results[i].assessor_name + this.username + ','
            id = res.data.results[i].id
            break
          } else {
            assessor_list = this.userid + ','
            assessor_name_list = this.username + ','
          }
        }
      } else {
        // 没有记录
        assessor_list = this.userid + ','
        assessor_name_list = this.username + ','
      }

      // 意见不能为空
      if (!this.assessSuggestion) {
        return this.$message.error('专家对项目的意见和建议不能为空！')
      }

      // 验证密码
      let resPass = await this.axios.get('/expertSignPass/?userid=' + this.userid)
      // 没有记录，需要先设置密码
      if (resPass.data.results.length == 0) {
        return this.$message.error('您还没有设置签名密码，请先在“专家管理>专家签名密码管理”页面设置密码！')
      } else if (!resPass.data.results[0].png) {
        return this.$message.error('您还没有上传签名，请先在“专家管理>专家签名密码管理”页面上传签名！')
      }
      // 验证密码
      if (this.password != resPass.data.results[0].password) {
        return this.$message.error('请输入正确的签名密码！')
      }

      // 写projectFinalCheck评审结果表        
      let data = {
        pid: this.projectAssess.pid,
        pname: this.projectAssess.pname,
        leader: this.projectAssess.leader,
        leader_name: this.projectAssess.leader_name,
        category: this.projectAssess.category,
        category_direction: this.projectAssess.category_direction,
        assess_date: this.assessDate,
        status: '已评审',
        assessor: assessor_list,
        assessor_name: assessor_name_list,
        assessor_result: {
          assessSuggestion: this.assessSuggestion,
          // assessScore: this.assessScore,
        }
      }
      // console.log('data', data)
      // alert(data)
      // 如果有记录，则更新，没有则新增
      let assessSuccsess = false
      if (id) {
        let resPut = await this.axios.put(`/projectFinalCheck/${id}/`, data)
        if (resPut.status == 200) {
          assessSuccsess = true
          this.$message.success('评审成功！')
        } else {
          this.$message.error('评审失败')
        }
      } else {
        let resPost = await this.axios.post('/projectFinalCheck/', data)
        if (resPost.status == 201) {
          assessSuccsess = true
          this.$message.success('评审成功！')
        } else {
          this.$message.error('评审失败')
        }
      }

      if (assessSuccsess) {
        // 删除projectDistribute
        let resGet = await this.axios.get('/projectDistribute/?status=结题验收' + '&pid=' + this.projectAssess.pid +
          '&assessor=' + this.userid)
        resGet = resGet.data.results[0]
        let resDel = await this.axios.delete(`/projectDistribute/${resGet.id}`)
        if (resDel.status == 204) {
          this.$message.success('评审成功！')
        } else {
          this.$message.error('评审失败')
        }
      } else {
        this.$message.error('新增评审记录失败，请稍后再试！')
      }

      // 对话框不可见，初始化课题列表
      this.assessDialogVisible = false
      // this.getProjectInfoDistribute()
      setTimeout(() => {
        location.reload()
      }, 500)
    },


    // 保存评审结果
    async save() {
      return
      // 先查询是否有保存记录
      let assessor_list = ""
      let assessor_name_list = ""
      let res = await this.axios.get('/projectFinalCheck/?pid=' + this.projectAssess.pid)
      let id = "" //记录有assessor的记录的id，有则更新，没有则新增

      if (res.data.results.length > 0) {
        // 循环查询结果，找出assessor不为空的记录
        for (let i = 0; i < res.data.results.length; i++) {
          if (res.data.results[i].assessor) {
            assessor_list = res.data.results[i].assessor + this.userid + ','
            assessor_name_list = res.data.results[i].assessor_name + this.username + ','
            id = res.data.results[i].id
            break
          } else {
            assessor_list = this.userid + ','
            assessor_name_list = this.username + ','
          }
        }
      } else {
        // 没有记录
        assessor_list = this.userid + ','
        assessor_name_list = this.username + ','
      }

      // 意见不能为空
      if (!this.assessSuggestion) {
        return this.$message.error('专家对项目的意见和建议不能为空！')
      }

      // 验证密码
      let resPass = await this.axios.get('/expertSignPass/?userid=' + this.userid)
      // 没有记录，需要先设置密码
      if (resPass.data.results.length == 0) {
        return this.$message.error('您还没有设置签名密码，请先在“专家管理>专家签名密码管理”页面设置密码！')
      } else if (!resPass.data.results[0].png) {
        return this.$message.error('您还没有上传签名，请先在“专家管理>专家签名密码管理”页面上传签名！')
      }
      // 验证密码
      if (this.password != resPass.data.results[0].password) {
        return this.$message.error('请输入正确的签名密码！')
      }

      // 写projectFinalCheck评审结果表        
      let data = {
        pid: this.projectAssess.pid,
        pname: this.projectAssess.pname,
        leader: this.projectAssess.leader,
        leader_name: this.projectAssess.leader_name,
        category: this.projectAssess.category,
        category_direction: this.projectAssess.category_direction,
        assess_date: this.assessDate,
        status: '已评审',
        assessor: assessor_list,
        assessor_name: assessor_name_list,
        assessor_result: {
          assessSuggestion: this.assessSuggestion,
          // assessScore: this.assessScore,
        }
      }
      // console.log('data', data)
      // alert(data)
      // 如果有记录，则更新，没有则新增
      let assessSuccsess = false
      if (id) {
        let resPut = await this.axios.put(`/projectFinalCheck/${id}/`, data)
        if (resPut.status == 200) {
          assessSuccsess = true
          this.$message.success('评审成功！')
        } else {
          this.$message.error('评审失败')
        }
      } else {
        let resPost = await this.axios.post('/projectFinalCheck/', data)
        if (resPost.status == 201) {
          assessSuccsess = true
          this.$message.success('评审成功！')
        } else {
          this.$message.error('评审失败')
        }
      }
    },


    // 以下为查看信息相关函数

    // 获取课题信息
    async getProjectInfo(pid) {
      const res = await this.axios.get(`/projectInfo/?pid=${pid}`);
      if (res.status === 200) {
        // console.log('info', res.data.results)
        this.projectInfoShow = res.data.results[0];
      } else {
        this.$message.warning("错误");
      }
    },

    // 查询课题信息
    async queryProjectInfo() {
      // const res = await this.axios.get(`/projectInfoLite/?search=${this.query}`)
      const res = await this.axios.get(
        `/projectInfoLite/?search=${this.query}`
      );
      if (res.status === 200) {
        this.projectInfo = res.data.results;
      } else {
        this.$message.warning("错误");
      }
    },

    // 获取附件列表
    async getFileList(pid) {
      this.fileList = []
      this.fileListSignAgreement = []
      this.fileListMiddleCheck = []
      const res = await this.axios.get(`/fileList/?pid=${pid}`)
      if (res.status === 200) {
        this.fileList = res.data.results
      } else {
        this.$message.warning("获取文件列表错误")
      }
      // 保密协议、计划任务书
      const resAgreement = await this.axios.get(`/fileList/?pid=${pid}` + '/保密协议及计划任务书')
      if (resAgreement.status === 200) {
        let files = resAgreement.data.results
        this.fileListSignAgreement = []
        for (let i = 0; i < files.length; i++) {
          // 如果名称包含“计划任务书”，则添加到fileListSignAgreement
          if (files[i].name.includes("计划任务书")) {
            this.fileListSignAgreement.push(files[i])
          }
        }
      } else {
        this.$message.warning("获取文件列表错误")
      }
      // 测试数据与分析报告
      const resTest = await this.axios.get(`/fileList/?pid=${pid}` + '/测试数据与分析报告')
      if (resTest.status === 200) {
        this.fileListTestData = resTest.data.results
      } else {
        this.$message.warning("获取文件列表错误")
      }
      // 中期检查
      const resMiddle = await this.axios.get(`/fileList/?pid=${pid}` + '/中期检查阶段成果报告')
      if (resMiddle.status === 200) {
        this.fileListMiddleCheck = resMiddle.data.results
      } else {
        this.$message.warning("获取文件列表错误")
      }
      // 结题验收
      const resFinal = await this.axios.get(`/fileList/?pid=${pid}` + '/结题材料')
      if (resFinal.status === 200) {
        this.fileListFinalCheck = resFinal.data.results
      } else {
        this.$message.warning("获取文件列表错误")
      }
    },

    // 查询主持人信息
    async getProjectLeader(userid) {
      const res = await this.axios.get(`/user/?userid=${userid}`);
      if (res.status === 200) {
        this.projectLeader = res.data.results;
        this.leader = this.projectLeader[0];
      } else {
        this.$message.warning("错误");
      }
    },

    // 获取username
    async getUserName(userid) {
      const res = await this.axios.get(`/user/?userid=${userid}`);
      if (res.status === 200) {
        return this.projectLeader[0].username;
      } else {
        this.$message.warning("错误");
      }
    },

    // 查询参加者
    async getProjectMember(id) {
      const res = await this.axios.get(`/projectMember/?pid=${id}`);
      if (res.status === 200) {
        this.projectMember = res.data.results;
      } else {
        this.$message.warning("错误");
      }
    },

    //获取状态名称
    statusName(id) {
      name = "";
      this.projectStatus.forEach((s) => {
        if (s.s_id == id) {
          name = s.status;
        }
      });
      return name;
    },

    // // 获取类别名称
    // categoryName(id) {
    //   const item = this.projectCategorys.find((item) => item.id == id);
    //   return item ? item.name : null;
    // },



    // 显示查看申报书卡片
    showInfoForm(item) {
      this.infoFormVisible = true;
      this.pid = item.pid; //查看图片、下载原文件用
      this.getProjectInfo(item.pid);
      this.editForm = this.projectInfoShow;
      // console.log('editForm', this.editForm)

      // this.selectValue = this.categoryName(this.editForm.category); //讲id转换成文字
      this.getProjectMember(item.pid);
      this.getFileList(item.pid);
      this.auditInfo = {};
      // this.getAuditInfo(item.pid);
      this.getProjectLeader(this.editForm.leader);



      setTimeout(() => {
        document.getElementById("id-el-card-info").scrollIntoView({
          behavior: "smooth",
        });
      }, 500);
    },

    // 按钮 查看图片
    ButtonShowPng() {
      this.infoDialogVisible = true;
    },
    ButtonDownOriginFile() {
      let name = "课题申请书" + this.pid + ".pdf";
      let path = "./toPdf/pdf_temp/" + name;
      let item = {
        path: path,
        name: name,
      };
      this.downloadFile(item);
    },

    // 隐藏课题对话框
    infoDialogHide() {
      this.infoDialogVisible = false;
    },

    // 下载文件
    downloadFile(item) {
      let url = `/downloadFile/?path=${item.path}&name=${item.name}`;
      let params = {
        path: item.path,
        name: item.name,
      };
      this.axios
        .post(url, params, {
          responseType: "arraybuffer",
        })
        .then((res) => {
          fileDownload(res.data, item.name);
        });
    },
    // 删除文件
    async deleteFile(item) {
      let res = await this.axios.delete("/fileList/" + item.id + "/");
      if (res.status === 204) {
        this.getFileList(item.pid);
      }
      let data = {
        path: item.path,
      };
      let resDelete = await this.axios.post("/deleteFile/", data);
      // console.log(resDelete)
    },
  },
}

</script>

<style lang="less">
.el-card {
  margin-top: 15px;
}

.header-edit {
  font-size: 18px;
  text-align: left;
  margin-bottom: 10px;
}

.el-col-user-add {
  display: flex;
}

.user-search {
  width: 420px;
  margin-right: 10px;
}

.el-col-addForm {
  display: flex;
  margin-bottom: 10px;

  span {
    display: flex;
    align-items: center;
    margin-left: 10px;
  }

  .el-input {
    width: 400px;
  }
}

.el-card-leader {
  .div-leader {
    font-size: 16px;
    margin-bottom: 15px;
  }
}

.member {
  font-size: 16px;
  margin-bottom: 15px;
}

.el-row-detail {
  width: 1020px;

  .el-col {
    display: flex;

    span {
      display: flex;
      align-items: center;
      margin-left: 10px;
    }

    .el-input {
      width: 200px;
    }
  }
}

.editor {
  margin-top: 15px;
}

.ql-editor {
  min-height: 200px;
}

.div-upload {
  width: 500px;
  padding-top: 10px;
}

.div-add {
  margin-top: 20px;
  display: flex;
  justify-content: end;
}

.div-file {
  margin-top: 15px;
}

.el-dialog {
  width: 900px;

  .divScore {
    font-size: 20px;
  }

  .el-radio {
    margin-left: 20px;
    width: 70px;
  }

  .divSuggestion {
    font-size: 20px;
    margin-bottom: 20px;
  }

  .divAgree {
    font-size: 20px;
    margin-bottom: 20px;
  }

  .el-button {
    margin-top: 30px;
  }
}

// pdf预览
.onlineHelp {
  height: 100%;
  position: relative;
  display: flex;
  justify-content: center;

  .tools {
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 999;
    margin-top: -50px;

    .page {
      display: inline-block;
      margin-right: 10px;
    }
  }

  .pdf-box {
    height: 100%;
    overflow: auto;
    width: 90%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/finalCheck/FinalAssessor.vue